import script from "./AuditView.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditView.vue?vue&type=script&setup=true&lang=js"

import "./AuditView.vue?vue&type=style&index=0&id=4ab5d3fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab5d3fc"]])

export default __exports__